import {
  Checkbox,
  message,
  Select,
  PageHeader,
  Col,
  Row,
  Spin,
  Popconfirm,
  Form as FormInitial,
  Upload,
  Alert
} from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  PlusOutlined, UploadOutlined, DeleteOutlined, StarFilled, StarOutlined,
} from "@ant-design/icons";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  cuentaMask,
  InputItem,
  ButtonItem,
  TextAreaItem,
  SwitchItem,
  ErrorItem,
  extraerDatosConstanciaFiscal,
  calcularSimilitud,
  TabbedDynamicTable,
  DynamicCardForm,
} from "../../../../Components/Items";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import FormListLeyendasFiscales from "../../../../Components/FormListLeyendasFiscales";
import { getDefaultCamposObligatorios } from "../camposClientesConfig";

const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class AgregarCliente extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    camposObligatorios: getDefaultCamposObligatorios(),
    todasMonedas: null,
    objetoMonedas: null,
    todasPaises: null,
    objetoPaises: null,
    todasPaisesResidencia: null,
    objetoPaisesResidencia: null,
    todasEstados: null,
    objetoEstados: null,
    todasMunicipios: null,
    objetoMunicipios: [],
    todasColonias: null,
    objetoColonias: [],
    todasCuentaContable: null,
    objetoCuentaContable: null,
    todasBancosSat: null,
    objetoBancosSat: null,
    todasTiposDeOperacion: null,
    objetoTiposDeOperacion: null,
    todasTiposDeTerceros: null,
    objetoTiposDeTerceros: null,
    todasTipoDeCliente: null,
    objetoTipoDeCliente: null,
    todasPrecios: null,
    objetoPrecios: null,
    todasUsosDeCFDI: null,
    objetoUsosDeCFDI: null,
    todasProyectos: null,
    objetoProyectos: null,
    todasVendedores: null,
    objetoVendedores: null,
    objetoCanalesVenta: null,
    todasRegimenFiscal: null,
    objetoRegimenFiscal: null,
    todasRetenciones: null,
    todasFormasDePago: null,
    objetoFormasDePago: null,
    objetoRetenciones: null,
    objetoBancos: null,
    objetoPlantasEntrega: null,
    loadingPlantasEntrega: null,
    archivosCliente: [],
    filePreviewVisible: false,
    currentPreviewFile: null,
    maximoArchivos: 3,
    factorajeFinancieroCXC: false,
    complementoComercioExterior: false,
    complementoEmpresaAlterna: false,
    objetoMunicipiosAlterna: null,
    objetoColoniasAlterna: null,
    archivoLogoAlterna: null,
    base64LogoAlterna: null,
  };
  atras() {
    this.props.history.goBack();
  }
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/selectDatosParaCliente",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            camposObligatorios: res.data.camposObligatorios || getDefaultCamposObligatorios(),
            factorajeFinancieroCXC: res.data.factorajeFinancieroCXC,
            complementoComercioExterior: res.data.complementoComercioExterior,
            complementoEmpresaAlterna: res.data.complementoEmpresaAlterna,
            todasProyectos: res.data.proyectos,
            todasUsosDeCFDI: res.data.usosDeCFDI,
            todasPrecios: res.data.precios,
            todasBancosSat: res.data.bancosSat,
            todasTipoDeCliente: res.data.tipoDeClientes,
            todasCuentaContable: res.data.cuentasContables,
            todasMonedas: res.data.monedas,
            todasPaises: res.data.paises,
            todasPaisesResidencia: res.data.paisesResidencia,
            todasRegimenFiscal: res.data.regimenesFiscales,
            todasRetenciones: res.data.retenciones,
            todasVendedores: res.data.vendedores,
            todasBancos: res.data.bancos,
            todasFormasDePago: res.data.formasDePago,
            maximoArchivos: res.data.maximoArchivos,
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            objetoPaises: res.data.paises.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoPaisesResidencia: res.data.paisesResidencia?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoEstados: res.data.estados.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoCuentaContable: res.data.cuentasContables.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
            objetoTipoDeCliente: res.data.tipoDeClientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoBancosSat: res.data.bancosSat.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              );
            }),
            objetoPrecios: res.data.precios.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_UsoCFDI + ' - ' + value.descripcion}
                </Option>
              );
            }),
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoRetenciones: res.data.retenciones.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoVendedores: res.data.vendedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
            objetoCanalesVenta: res.data.canalesVenta?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.codigo + " - " + value.nombre}
                </Option>
              );
            }),
            objetoBancos: res.data.bancos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoFormasDePago : res.data.formasDePago?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.descripcion}
                </Option>
              );
            })
          });
          this.formRef.current.setFieldsValue({
            codigo: res.data.sigNumero,
            clave: res.data.sigNumero,
          });
        }
      });
    this.setState({ loading: false });
  }
  // Marca una sola cuenta como predeterminada: es la que se propone por default
  // en el complemento de pago al cobrar una venta de este cliente
  marcarCuentaPredeterminada(indice) {
    const cuentas = this.formRef.current.getFieldValue("cuentasBancoCliente") || [];
    const yaEraPredeterminada = !!cuentas[indice]?.predeterminada;
    this.formRef.current.setFieldsValue({
      cuentasBancoCliente: cuentas.map((cuenta, i) => ({
        ...cuenta,
        predeterminada: yaEraPredeterminada ? false : i === indice,
      })),
    });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values.empresaAlterna?.activo) {
      const ea = values.empresaAlterna;
      const faltaAlgo =
        !ea.nombre || !ea.rfc || !ea.paisId || !ea.estadoId ||
        !ea.municipioId || !ea.coloniaId || !this.state.archivoLogoAlterna;
      if (faltaAlgo) {
        message.error(
          "Para activar la Empresa Alterna debes llenar nombre, RFC, dirección completa (país, estado, municipio y colonia) y subir un logo"
        );
        return;
      }
    }

    this.setState({ loading: true });

    let empresaAlterna = values.empresaAlterna;
    if (empresaAlterna?.activo && this.state.archivoLogoAlterna) {
      empresaAlterna = {
        ...empresaAlterna,
        logoBase64: this.state.base64LogoAlterna,
        logoName: this.state.archivoLogoAlterna.name,
      };
    }

    axios
      .post(
        "clientes/agregarCliente",
        {
          ...values,
          empresaAlterna,
          empresaId: this.props.empresaId,
          archivos: this.state.archivosCliente
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado un cliente");
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.warning(
            res.data.message
              ? res.data.message
              : "No se puede registrar el cliente"
          );
        } else {
          message.error("Hubo un error y el cliente no se registro");
        }
      });
  }
  onChangeEstado(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === "undefined") {
        direcciones[fieldKey] = {};
      }
      direcciones[fieldKey].municipioId = undefined;
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
      let objetoColonias = this.state.objetoColonias;
      objetoColonias[fieldKey] = null;
      this.setState({ objetoColonias: objetoColonias });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMunicipios: res.data });
          let objetoMunicipios = this.state.objetoMunicipios;
          objetoMunicipios[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoMunicipios: objetoMunicipios,
          });
        }
      });
  }
  onChangeMunicipio(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === "undefined") {
        direcciones[fieldKey] = {};
      }
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasColonias: res.data });
          let objetoColonias = this.state.objetoColonias;
          objetoColonias[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.cp + " - " + value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoColonias: objetoColonias,
          });
        }
      });
  }
  // Dirección de la Empresa Alterna: cascada propia, independiente de la de
  // "Direcciones" del cliente (que es un arreglo indexado por fieldKey).
  onChangeEstadoAlterna(value) {
    const empresaAlterna = this.formRef.current.getFieldValue("empresaAlterna") || {};
    this.formRef.current.setFieldsValue({
      empresaAlterna: { ...empresaAlterna, municipioId: undefined, coloniaId: undefined },
    });
    this.setState({ objetoMunicipiosAlterna: null, objetoColoniasAlterna: null });
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            objetoMunicipiosAlterna: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
  }
  onChangeMunicipioAlterna(value) {
    const empresaAlterna = this.formRef.current.getFieldValue("empresaAlterna") || {};
    this.formRef.current.setFieldsValue({
      empresaAlterna: { ...empresaAlterna, coloniaId: undefined },
    });
    this.setState({ objetoColoniasAlterna: null });
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            objetoColoniasAlterna: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.cp + " - " + value.nombre}</Option>
            )),
          });
        }
      });
  }
  async onChangeArchivoLogoAlterna(e) {
    const file = e.file;
    if (file.type === "image/jpeg" || file.type === "image/png") {
      const base64 = await getBase64(file);
      this.setState({ archivoLogoAlterna: file, base64LogoAlterna: base64 });
      e.onSuccess("ok");
    } else {
      message.error("El logo debe ser una imagen");
      e.onError("Formato inválido");
    }
  }
  onChangeTipoDeCliente(value) {
    const tipoDeCliente = this.state.todasTipoDeCliente.find(
      (valueTodos) => valueTodos._id.toString() === value.toString()
    );
    if (tipoDeCliente.generarCuentasAutomatico) {
      this.formRef.current.setFieldsValue({
        cuentaClienteId: "Se generara al guardarlo",
        cuentaAnticipoId: "Se generara al guardarlo",
        generarCuentaAnticipoId: false,
        cuentaFonGarId: "Se generara al guardarlo",
        generarCuentaFonGarId: false,
        cuentaDeudorId: "Se generara al guardarlo",
        generarCuentaDeudorId: false,
      });
    } else {
      this.formRef.current.setFieldsValue({
        cuentaClienteId: tipoDeCliente.cuentaClienteId,
        cuentaAnticipoId: tipoDeCliente.cuentaAnticipoId,
        generarCuentaAnticipoId: false,
        cuentaFonGarId: tipoDeCliente.cuentaFonGarId,
        generarCuentaFonGarId: false,
        cuentaDeudorId: tipoDeCliente.cuentaDeudorId,
        generarCuentaDeudorId: false,
      });
    }
  }
  async onSearchColonia(value, fieldKey, ponerColoniaId) {
    if (value.toString().length === 5) {
      await axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            let direcciones = this.formRef.current.getFieldValue("direcciones");
            if (typeof direcciones[fieldKey] === "undefined") {
              direcciones[fieldKey] = {};
            }
            if (ponerColoniaId && res.data._id) {
              direcciones[fieldKey].coloniaId = res.data._id;
            }
            direcciones[fieldKey].paisId = res.data.paisId;
            direcciones[fieldKey].estadoId = res.data.estadoId;
            direcciones[fieldKey].municipioId = res.data.municipioId;
            this.formRef.current.setFieldsValue({
              direcciones: direcciones,
            });
            this.onChangeEstado(res.data.estadoId, fieldKey, true);
            this.onChangeMunicipio(res.data.municipioId, fieldKey, true);
          }
        });
    }
  }
  async onSelectColoniaId(coloniaId, fieldKey) {
    const direcciones = this.formRef.current.getFieldValue("direcciones");
    if (typeof direcciones[fieldKey] === "undefined") {
      direcciones[fieldKey] = {};
    }
    if (!direcciones[fieldKey].colonia) {
      const nombreColonia = this.state.todasColonias.find(
        (todasColonia) => todasColonia._id.toString() === coloniaId.toString()
      )?.nombre;
      direcciones[fieldKey].colonia = nombreColonia;
      await this.formRef.current.setFieldsValue({
        direcciones: direcciones,
      });
    }
  }
  async onChangeRfc(e) {
    this.formRef.current
      .validateFields(["rfc"])
      .then(() => {
        if (e.target.value) {
          if (e.target.value.length === 13) {
            //Persona Fisica
            this.formRef.current.setFieldsValue({ persona: false });
          } else if (e.target.value.length === 12) {
            //Persona Moral
            this.formRef.current.setFieldsValue({ persona: true });
          }
        }
      })
      .catch((err) => undefined);
  }
  onChangeRegimenFiscal(regimenFiscalId) {
    const retencionAgregar = this.state.todasRetenciones.find(
      (todasRetenciones) =>
        todasRetenciones.regimenFiscalId.toString() ===
        regimenFiscalId.toString()
    );
    const retenciones = this.formRef.current.getFieldValue("retenciones");
    if (retencionAgregar) {
      if (retenciones) {
        const findRetencion = retenciones.find(
          (todasRetencionesProv) =>
            todasRetencionesProv.retencionId.toString() ===
            retencionAgregar._id.toString()
        );
        if (!findRetencion) {
          this.formRef.current.setFieldsValue({
            retenciones: [
              ...retenciones,
              { retencionId: retencionAgregar._id },
            ],
          });
        }
      } else {
        this.formRef.current.setFieldsValue({
          retenciones: [{ retencionId: retencionAgregar._id }],
        });
      }
    }
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true });
    if (e.file.type === "application/pdf") {
      const datosConstancia = await extraerDatosConstanciaFiscal(e.file);
      if (datosConstancia.persona === 1) {
        if (
          datosConstancia.rfc &&
          datosConstancia.nombre &&
          datosConstancia.apellidoPaterno &&
          datosConstancia.codigoPostal
        ) {
          const findRegimen = this.state.todasRegimenFiscal.find(
            (valueTRe) =>
              calcularSimilitud(
                valueTRe.descripcion,
                datosConstancia.regimenFiscal
              ) > 65
          );
          this.onSearchColonia(datosConstancia.codigoPostal, 0, true);
          this.formRef.current.setFieldsValue({
            rfc: datosConstancia.rfc,
            curp: datosConstancia.curp,
            nombre: datosConstancia.nombre,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            apellidoPaterno: datosConstancia.apellidoPaterno,
            apellidoMaterno: datosConstancia.apellidoMaterno,
            nombreComercial: datosConstancia.nombreComercial,

            direcciones: [
              {
                calle: datosConstancia.calle,
                numeroCalle: datosConstancia.numeroExterior,
                numeroInterior: datosConstancia.numeroInterior,
                colonia: datosConstancia.colonia,
                codigoPostal: datosConstancia.codigoPostal,
              },
            ],
            persona: false,
          });
        } else {
          message.error("No se pudo leer bien el archivo");
        }
      } else if (datosConstancia.persona === 2) {
        if (
          datosConstancia.rfc &&
          datosConstancia.razonSocial &&
          datosConstancia.codigoPostal
        ) {
          this.onSearchColonia(datosConstancia.codigoPostal, 0, true);
          const findRegimen = this.state.todasRegimenFiscal.find(
            (valueTRe) =>
              calcularSimilitud(
                valueTRe.descripcion,
                datosConstancia.regimenFiscal
              ) > 65
          );
          this.formRef.current.setFieldsValue({
            razonSocial: datosConstancia.razonSocial,
            rfc: datosConstancia.rfc,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            curp: datosConstancia.curp,
            nombreComercial: datosConstancia.nombreComercial,

            direcciones: [
              {
                calle: datosConstancia.calle,
                numeroCalle: datosConstancia.numeroExterior,
                numeroInterior: datosConstancia.numeroInterior,
                colonia: datosConstancia.colonia,
                codigoPostal: datosConstancia.codigoPostal,
              },
            ],
            persona: true,
          });
        } else {
          message.error("No se pudo leer bien el archivo");
        }
      } else {
        message.error("No se pudo leer bien el archivo");
      }
    } else {
      message.error("El archivo debe ser un archivo pdf");
    }
    this.setState({ loading: false });
  }

  onSearchPlantaEntrega = (value, fieldKey) => {
    this.setState((prev) => ({
      loadingPlantasEntrega: {
        ...prev.loadingPlantasEntrega,
        [fieldKey]: true,
      },
    }));
    axios
      .post(
        "plantaDeEntrega/selectPlantasDeEntrega",
        {
          query: value || "",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res?.data.success !== 2) {
          this.setState((prev) => ({
            objetoPlantasEntrega: {
              ...prev.objetoPlantasEntrega,
              [fieldKey]: [],
            },
            loadingPlantasEntrega: {
              ...prev.loadingPlantasEntrega,
              [fieldKey]: false,
            },
          }));
          return;
        }
        const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
        const options = items.map((it) => (
          <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
            {it.label}
          </Option>
        ));

        this.setState((prev) => ({
          objetoPlantasEntrega: {
            ...prev.objetoPlantasEntrega,
            [fieldKey]: options,
          },
          loadingPlantasEntrega: {
            ...prev.loadingPlantasEntrega,
            [fieldKey]: false,
          },
        }));
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al buscar plantas de entrega");
        this.setState((prev) => ({
          objetoPlantasEntrega: {
            ...prev.objetoPlantasEntrega,
            [fieldKey]: [],
          },
          loadingPlantasEntrega: {
            ...prev.loadingPlantasEntrega,
            [fieldKey]: false,
          },
        }));
      });
  };

  //Funciones para los archivos
  onRemoveFile(e) {
    let index = this.state.archivosCliente.indexOf(e);
    let nuevoArray = this.state.archivosCliente;
    nuevoArray.splice(index, 1);
    this.setState({ archivosCliente: nuevoArray });
  }
  async customRequestArchivos(e) {
    const file = e.file;
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError('Archivo demasiado grande');
      return;
    }
    const base64 = await getBase64(file);

    const nuevoArchivo = {
      uid: file.uid,
      name: file.name,
      status: 'done',
      url: base64,
      originFileObj: file,
    };


    this.setState({
      archivosCliente: [...this.state.archivosCliente, nuevoArchivo],
    });

    e.onSuccess("ok");
  }
  beforeUploadArchivos = (file, fileList) => {
    const { archivosCliente, maximoArchivos } = this.state;
    const totalProyectado = archivosCliente.length + fileList.length;

    if (totalProyectado > maximoArchivos) {
      if (file === fileList[0]) {
        message.error(`Con esta selección, superarías el límite de ${maximoArchivos} archivos.`);
      }
      return Upload.LIST_IGNORE;
    }

    const isLt25M = file.size / 1024 / 1024 < 25;
    if (!isLt25M) {
      message.error(`${file.name} excede el tamaño máximo de 25MB`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  handlePreview = async (file) => {
    // Usar el FilePreviewModal para todos los archivos
    this.setState({
      currentPreviewFile: file,
      filePreviewVisible: true,
    });
  };
  handleCancel = () => this.setState({ previewVisible: false });
  handleCloseFilePreview = () => {
    this.setState({
      filePreviewVisible: false,
      currentPreviewFile: null,
    });
  };

  render() {
    const { filePreviewVisible, currentPreviewFile, camposObligatorios } = this.state;
    const esEmpresaEspecial = this.props.empresaId === '6949999f814dca4f7c54c4d6';
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Cliente"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Upload
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={[]}
              customRequest={this.onChangeArchivo.bind(this)}
              accept=".pdf"
              maxCount={this.state.maximoArchivos}
            >
              <ButtonItem blanco icon={<UploadOutlined />}>
                Leer Constancia
              </ButtonItem>
            </Upload>
          }
        />
        <div className="card-background" style={{ paddingTop: 20 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarCliente"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  cyan
                  style={{ display: "block", margin: "0 0 0 auto",minWidth: 120,height: 30, }}

                >
                  Guardar Cliente
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
              initialValues={{
                monedaId: "60c7e4396465ad440c41c15a",
              }}
            >
              <TabbedDynamicTable
                defaultActiveKey="1"
                tabs={[
                  {
                    key: '1',
                    label: 'General',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          {/* ===================== DATOS GENERALES ===================== */}
                          <Col span={12} xs={24} lg={13}>
                            <DynamicCardForm title={<span>Datos Generales</span>}>
                              <Row>
                                <Col span={12}>
                                  <FormItem name="codigo" margin label="Codigo" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                    <InputItem disabled placeholder="Codigo" />
                                  </FormItem>
                                </Col>

                                <Col span={12}>
                                  <FormItem name="clave" margin pattern required={!!camposObligatorios.clave} label="Clave" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                    <InputItem placeholder="Clave" />
                                  </FormItem>
                                </Col>
                              </Row>

                              <Row>
                                <Col span={12}>
                                  <FormItem name="rfc" label="RFC" margin required rfc labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                    <InputItem
                                      onChange={this.onChangeRfc.bind(this)}
                                      placeholder="RFC"
                                    />
                                  </FormItem>
                                </Col>

                                <Col span={12}>
                                  <FormItem name="persona" label="P. Moral" margin valuePropName="checked" initialValue={false} labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}>
                                    <Checkbox />
                                  </FormItem>
                                </Col>
                              </Row>

                              <Row>
                                <Col span={12}>
                                  <FormItem shouldUpdate margin noStyle>
                                    {({ getFieldValue }) =>
                                      !getFieldValue("persona") && (
                                        <FormItem name="curp" label="CURP" margin pattern max={20} required={!!camposObligatorios.curp} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                          <InputItem placeholder="CURP" />
                                        </FormItem>
                                      )
                                    }
                                  </FormItem>
                                </Col>
                              </Row>

                              <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                                <FormItem shouldUpdate noStyle>
                                  {({ getFieldValue }) =>
                                    getFieldValue("persona") && (
                                      <FormItem name="razonSocial" label="Razon Social" margin pattern max={200} labelCol={{ span: 3 }} wrapperCol={{ span: 21 }} required>
                                        <InputItem placeholder="Razón Social" />
                                      </FormItem>
                                    )
                                  }
                                </FormItem>
                              </Col>

                              <Row>
                                <Col span={10} xs={24} sm={24} lg={9} xl={9}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            label="Nombre"
                                            margin
                                            pattern
                                            required
                                            name="nombre"
                                            labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 3 } }}
                                            wrapperCol={{ lg: { span: 16 }, xl: { span: 16 }, xs: { span: 21 } }}
                                          >
                                            <InputItem
                                              placeholder="Nombre persona física"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={7} xs={24} sm={24} lg={7} xl={7}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            margin
                                            pattern
                                            name="apellidoPaterno"
                                            required={!!camposObligatorios.apellidoPaterno}
                                            labelCol={{ lg: { span: 0 }, xl: { span: 0 }, xs: { span: 20 } }}
                                            wrapperCol={{ span: 24 }}
                                          >
                                            <InputItem
                                              placeholder="Apelido Paterno"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={7} xs={24} sm={24} lg={7} xl={7}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            margin
                                            pattern
                                            name="apellidoMaterno"
                                            required={!!camposObligatorios.apellidoMaterno}
                                            labelCol={{ span: 0 }}
                                            wrapperCol={{ span: 24 }}
                                          >
                                            <InputItem placeholder="Apellido Materno" width="98%" />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>

                              <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                                <FormItem
                                  shouldUpdate={(prev, cur) => prev.rfc !== cur.rfc}
                                  noStyle
                                >
                                  {({ getFieldValue }) =>
                                    getFieldValue("rfc") === "XEXX010101000" && (
                                      <Row gutter={[16, 0]}>
                                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                          <FormItem
                                            label="ID Trib."
                                            name="registroIDTributario"
                                            margin
                                            pattern
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            tooltip="Número de Registro de Identificación Tributaria del extranjero"
                                          >
                                            <InputItem placeholder="Ej: VAT-DE123456789" />
                                          </FormItem>
                                        </Col>
                                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                          <FormItem
                                            label="Residencia Fiscal"
                                            name="paisResidenciaId"
                                            margin
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 16 }}
                                          >
                                            <SelectItem placeholder="Residencia Fiscal">
                                              {this.state.objetoPaisesResidencia}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                      </Row>
                                    )
                                  }
                                </FormItem>
                              </Col>

                              <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                                <FormItem
                                  name="nombreComercial"
                                  pattern
                                  max={200}
                                  required={!!camposObligatorios.nombreComercial}
                                  labelCol={{ span: 3 }}
                                  wrapperCol={{ span: 21 }}
                                  label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Nombre Comercial</span>}
                                  margin
                                >
                                  <InputItem placeholder="Nombre Comercial" />
                                </FormItem>
                              </Col>
                            </DynamicCardForm>

                            {/* ===================== CONTACTO GENERAL ===================== */}
                            <DynamicCardForm title={<span>Contacto General</span>}>
                              <Row>
                                <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                  <FormItem name="nombreContactoGeneral" margin pattern max={200} required={!!camposObligatorios.nombreContactoGeneral} labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} label="Nombre">
                                    <InputItem placeholder="Nombre de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem name="celular" number margin required={esEmpresaEspecial || !!camposObligatorios.celular} labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }} label="Celular">
                                    <InputNumberItem placeholder="Celular" celular />
                                  </FormItem>

                                  <FormItem name="telefono" number margin labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }} label="Teléfono">
                                    <InputNumberItem placeholder="Teléfono" celular />
                                  </FormItem>
                                </Col>

                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem name="paginaWeb" margin pattern max={200} labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }} label="Página Web">
                                    <InputItem placeholder="Página Web" />
                                  </FormItem>

                                  <FormItem name="correo" margin required={esEmpresaEspecial || !!camposObligatorios.correo} pattern max={200} email labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }} label="Correo">
                                    <InputItem placeholder="Correo" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                  <FormItem margin pattern required={!!camposObligatorios.observaciones} labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} name="observaciones" label="Observaciones">
                                    <TextAreaItem placeholder="Observaciones" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    name="impresionEspecial"
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Impresion Especial</span>}
                                    margin
                                    required={!!camposObligatorios.impresionEspecial}
                                    rules={!!camposObligatorios.impresionEspecial ? [{ validator: (_, v) => v ? Promise.resolve() : Promise.reject(new Error('Debes activar Impresión Especial')) }] : []}
                                    valuePropName="checked"
                                    initialValue={false}
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 19 }}
                                  >
                                    <Checkbox />
                                  </FormItem>
                                </Col>
                              </Row>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  const usaAdenda = getFieldValue("usarAdenda");
                                  const esViscofan = getFieldValue("adendaActiva") === "Viscofan";
                                  const campoObligatorio = usaAdenda && esViscofan;

                                  return (
                                    <FormItem
                                      label="Código Proveedor"
                                      name="codigoProveedor"
                                      pattern
                                      max={9}
                                      margin
                                      required={campoObligatorio || !!camposObligatorios.codigoProveedor}
                                      labelCol={{ span: 4 }}
                                      wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                    >
                                      <InputItem placeholder="Código de Proveedor" />
                                    </FormItem>
                                  );
                                }}
                              </FormItem>
                            </DynamicCardForm>
                          </Col>

                          {/* ===================== DATOS VENTA ===================== */}
                          <Col span={12} xs={24} lg={11}>
                            <DynamicCardForm title={<span>Datos Venta</span>}>
                              <FormItem
                                label="Tipo Cliente"
                                margin
                                name="tipoClienteId"
                                required
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <SelectItem
                                  placeholder="Tipo de Cliente"
                                  onChange={this.onChangeTipoDeCliente.bind(this)}
                                >
                                  {this.state.objetoTipoDeCliente}
                                </SelectItem>
                              </FormItem>

                              <FormItem
                                name="regimenFiscalId"
                                label="R. Fiscal"
                                margin
                                required={esEmpresaEspecial || !!camposObligatorios.regimenFiscalId}
                                tooltip={{
                                  title: "Campo necesario para facturación",
                                }}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <SelectItem
                                  onChange={this.onChangeRegimenFiscal.bind(this)}
                                  placeholder="Regimen Fiscal"
                                >
                                  {this.state.objetoRegimenFiscal}
                                </SelectItem>
                              </FormItem>

                              <FormItem name="usoDeCFDIID" margin required={esEmpresaEspecial || !!camposObligatorios.usoDeCFDIID} label="Uso de CFDI" labelCol={{ span: 7 }} wrapperCol={{ span: 16 }}>
                                <SelectItem placeholder="Uso de CFDI">
                                  {this.state.objetoUsosDeCFDI}
                                </SelectItem>
                              </FormItem>

                              <FormItem
                                name="proyectoId"
                                fieldKey="proyectoId"
                                label="Proyecto"
                                margin
                                required={esEmpresaEspecial || !!camposObligatorios.proyectoId}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <SelectItem placeholder="Proyecto">
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>

                              <FormItem name="vendedorId" margin required={!!camposObligatorios.vendedorId} label="Vendedor" fieldKey="vendedorId" labelCol={{ span: 7 }} wrapperCol={{ span: 16 }}>
                                <SelectItem placeholder="Vendedor">
                                  {this.state.objetoVendedores}
                                </SelectItem>
                              </FormItem>

                              <FormItem name="canalDeVentaId" margin label="Canal" fieldKey="canalDeVentaId" labelCol={{ span: 7 }} wrapperCol={{ span: 16 }}>
                                <SelectItem placeholder="Canal" allowClear>
                                  {this.state.objetoCanalesVenta}
                                </SelectItem>
                              </FormItem>

                              <FormItem
                                label="Método de pago"
                                name="contado"
                                margin
                                initialValue={1}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <SelectItem width="100%" disabled={!this.props.permisoModificarParametosDeCredito}>
                                  <Option value={1}>
                                    Contado - PUE : Pago en una sola exhibición
                                  </Option>
                                  <Option value={2}>
                                    Crédito - PPD : Pago en parcialidades o
                                    diferido
                                  </Option>
                                </SelectItem>
                              </FormItem>

                              <FormItem
                                name="bancoId"
                                fieldKey="bancoId"
                                label="Banco"
                                margin
                                required={!!camposObligatorios.bancoId}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <SelectItem placeholder="Banco">
                                  {this.state.objetoBancos}
                                </SelectItem>
                              </FormItem>

                              <FormItem
                                name="formaDePagoId"
                                fieldKey="formaDePagoId"
                                label="Forma de Pago"
                                margin
                                required={!!camposObligatorios.formaDePagoId}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                                tooltip={"Forma de pago predeterminada para el cliente."}
                              >
                                <SelectItem placeholder="Forma de Pago">
                                  {this.state.objetoFormasDePago}
                                </SelectItem>
                              </FormItem>

                              <FormItem
                                name="monedaId"
                                fieldKey="monedaId"
                                label="Moneda"
                                margin
                                required={!!camposObligatorios.monedaId}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                                tooltip={"Moneda predeterminada para el cliente."}
                              >
                                <SelectItem placeholder="Moneda">
                                  {this.state.objetoMonedas}
                                </SelectItem>
                              </FormItem>

                              <Row gutter={[8, 0]}>
                                <Col span={12}>
                                  <FormItem name="diasCredito" numberCero margin required={!!camposObligatorios.diasCredito} label="Días crédito" labelCol={{ span: 14 }} wrapperCol={{ span: 10 }}>
                                    <InputNumberItem disabled={!this.props.permisoModificarParametosDeCredito} />
                                  </FormItem>
                                  <FormItem name="limiteCredito" numberCero margin required={!!camposObligatorios.limiteCredito} label="Crédito" labelCol={{ span: 14 }} wrapperCol={{ span: 10 }}>
                                    <InputNumberItem dinero disabled={!this.props.permisoModificarParametosDeCredito} />
                                  </FormItem>
                                  <FormItem name="limiteDescuento" numberCero margin required={!!camposObligatorios.limiteDescuento} label="Desc. Máx" labelCol={{ span: 14 }} wrapperCol={{ span: 10 }}>
                                    <InputNumberItem porcentaje disabled={!this.props.permisoModificarParametosDeCredito} />
                                  </FormItem>
                                  {this.props.escuela && (
                                    <FormItem name="descuentoPredeterminado" numberCero margin label="Desc. Predet." labelCol={{ span: 14 }} wrapperCol={{ span: 10 }} tooltip="Se precarga como Desc. Cliente en cada renglón de ventas, pedidos, cotizaciones y embarques. En cada operación se le puede sumar un descuento adicional (en cascada).">
                                      <InputNumberItem porcentaje max={100} disabled={!this.props.permisoModificarParametosDeCredito} />
                                    </FormItem>
                                  )}
                                </Col>

                                <Col span={12}>
                                  <FormItem name="precioContadoId" fieldKey={"precioContadoId"} margin required={esEmpresaEspecial || !!camposObligatorios.precioContadoId} label="P. Contado" labelCol={{ span: 9 }} wrapperCol={{ span: 13 }}>
                                    <SelectItem placeholder="Precio Contado" disabled={!this.props.permisoModificarParametosDeCredito}>
                                      {this.state.objetoPrecios}
                                    </SelectItem>
                                  </FormItem>
                                  <FormItem name="precioCreditoId" fieldKey={"precioCreditoId"} margin required={!!camposObligatorios.precioCreditoId} label="P. Credito" labelCol={{ span: 9 }} wrapperCol={{ span: 13 }}>
                                    <SelectItem placeholder="Precio Credito" disabled={!this.props.permisoModificarParametosDeCredito}>
                                      {this.state.objetoPrecios}
                                    </SelectItem>
                                  </FormItem>
                                  <FormItem name="precioOnlineId" fieldKey={"precioOnlineId"} margin label="P. E-Commerce" labelCol={{ span: 9 }} wrapperCol={{ span: 13 }} tooltip="Lista de precios que verá este cliente en la tienda en línea. Vacío usa la del tipo de cliente.">
                                    <SelectItem placeholder="Usar la del tipo de cliente" allowClear disabled={!this.props.permisoModificarParametosDeCredito}>
                                      {this.state.objetoPrecios}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>

                              <Col span={24}>
                                <FormItem
                                  name="leyenda"
                                  label="Leyenda"
                                  required={!!camposObligatorios.leyenda}
                                  rules={!!camposObligatorios.leyenda ? [{ validator: (_, v) => v ? Promise.resolve() : Promise.reject(new Error('Debes activar Leyenda')) }] : []}
                                  valuePropName="checked"
                                  initialValue={false}
                                  margin
                                  labelCol={{ span: 7 }}
                                  wrapperCol={{ span: 14 }}
                                >
                                  <Checkbox />
                                </FormItem>
                              </Col>

                              <Col span={24}>
                                <FormItem
                                  name="clienteDePortal"
                                  label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Cliente De Portal</span>}
                                  margin
                                  required={!!camposObligatorios.clienteDePortal}
                                  rules={!!camposObligatorios.clienteDePortal ? [{ validator: (_, v) => v ? Promise.resolve() : Promise.reject(new Error('Debes activar Cliente De Portal')) }] : []}
                                  tooltip='Al activarse el cliente estará disponible en la sección de "Portal Clientes" para tener un seguimiendo de sus facturas.'
                                  valuePropName="checked"
                                  initialValue={false}
                                  labelCol={{ span: 7 }}
                                  wrapperCol={{ span: 14 }}
                                >
                                  <Checkbox />
                                </FormItem>
                              </Col>

                              <FormItem
                                shouldUpdate={(prevValues, curValues) => prevValues.clienteDePortal !== curValues.clienteDePortal}
                                noStyle
                              >
                                {({ getFieldValue }) =>
                                  getFieldValue("clienteDePortal") && (
                                    <Col span={24}>
                                      <FormItem
                                        name="sinFechaVencimiento"
                                        label="Sin Fecha de Vencimiento"
                                        margin
                                        tooltip='Al activarse, las ventas de este cliente se crean sin fecha de vencimiento ni fecha probable de pago.'
                                        valuePropName="checked"
                                        initialValue={false}
                                        labelCol={{ span: 7 }}
                                        wrapperCol={{ span: 14 }}
                                      >
                                        <Checkbox />
                                      </FormItem>
                                    </Col>
                                  )
                                }
                              </FormItem>
                            </DynamicCardForm>
                          </Col>

                        </Row>
                      </>
                    )
                  },
                  {
                    key: '2',
                    label: 'Contacto',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          {/* CORREOS ADICIONALES */}
                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                            <DynamicCardForm title={<span>Correos Adicionales</span>}>
                              <FormInitial.List name="correosAdicionales">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey}>
                                        <Col span={22}>
                                          <FormItem
                                            name={[name, "correo"]}
                                            fieldKey={[arrayKey, "correo"]}
                                            required
                                            margin
                                            noStyle
                                            email
                                            pattern
                                          >
                                            <InputItem placeholder="Correo" />
                                          </FormItem>
                                        </Col>
                                        <Col span={2}>
                                          <div style={{ textAlign: "center" }}>
                                            <ButtonItem
                                              type="text"
                                              danger
                                              icon={<DeleteOutlined />}
                                              onClick={() => remove(name)}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    {fields.length < 5 ? (
                                      <div
                                        style={{
                                          textAlign: "center",
                                          marginTop: "20px",
                                        }}
                                      >
                                        <ButtonItem
                                          type="primary"
                                          cyan
                                          onClick={() => add()}
                                          icon={<PlusOutlined />}
                                        >
                                          Agregar
                                        </ButtonItem>
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                          {/* DATOS DE CONTACTO */}
                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                            <DynamicCardForm title={<span>Datos de Contacto</span>}>
                              <Row>
                                <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                  <FormItem
                                    label="Nombre"
                                    name="nombreContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 19 }}
                                  >
                                    <InputItem placeholder="Nombre de Contacto" />
                                  </FormItem>
                                  <Row>
                                    <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                      <FormItem
                                        label="Teléfono"
                                        name="telefonoContacto"
                                        number
                                        margin
                                        labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 5 } }}
                                        wrapperCol={{ span: 16 }}
                                      >
                                        <InputNumberItem
                                          placeholder="Teléfono de Contacto"
                                          celular
                                        />
                                      </FormItem>
                                    </Col>
                                    <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                      <FormItem
                                        label="Correo"
                                        name="correoContacto"
                                        pattern
                                        max={200}
                                        email
                                        margin
                                        labelCol={{ lg: { span: 6 }, xl: { span: 6 }, xs: { span: 5 } }}
                                        wrapperCol={{ span: 16 }}
                                      >
                                        <InputItem placeholder="Correo de Contacto" />
                                      </FormItem>
                                    </Col>
                                  </Row>
                                  <FormItem
                                    label={
                                      <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>
                                        Personas pedidos
                                      </span>
                                    }
                                    name="personasPedidos"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 19 }}
                                  >
                                    <InputItem placeholder="Personas que atienden pedidos" />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    )
                  },
                  {
                    key: '3',
                    label: 'Retenciones',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm title={<span>Retenciones</span>}>
                              <FormInitial.List name="retenciones">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey}>
                                        <Col span={22}>
                                          <FormItem
                                            name={[name, "retencionId"]}
                                            fieldKey={[arrayKey, "retencionId"]}
                                            required
                                            margin
                                            noStyle
                                          >
                                            <SelectItem
                                              width="100%"
                                              placeholder="Retención"
                                            >
                                              {this.state.objetoRetenciones}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                        <Col span={2}>
                                          <div style={{ textAlign: "center" }}>
                                            <ButtonItem
                                              type="text"
                                              danger
                                              icon={<DeleteOutlined />}
                                              onClick={() => remove(name)}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    <div style={{ textAlign: "center", marginTop: 16 }}>
                                      <ButtonItem
                                        type="primary"
                                        cyan
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                      >
                                        Agregar
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    )
                  },
                  {
                    key: '5',
                    label: 'Direcciones',
                    forceRender: true,
                    customContent: (
                      <>
                        <FormInitial.List name="direcciones">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(
                                ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                  <React.Fragment key={key}>
                                    {arrayKey === 0 && (
                                      <div style={{ padding: "16px", textAlign: "center" }}>
                                        <Row>
                                          <Col span={24}>
                                            <h2 style={{ color: "#556B2F", margin: 0 }}>
                                              Dirección de Facturación
                                            </h2>
                                            <p style={{ textAlign: "center", marginBottom: "20px" }}>
                                              Campos necesarios para facturación
                                            </p>
                                          </Col>
                                        </Row>
                                      </div>
                                    )}
                                    <div className="card-punteada">
                                    <Row gutter={16}>
                                      <Col span={13} xs={24} sm={24} lg={13} xl={13}>
                                        <DynamicCardForm title={<span>Dirección</span>}>
                                        <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                shouldUpdate={(prev, cur) => prev.rfc !== cur.rfc}
                                                noStyle
                                              >
                                                {({ getFieldValue }) =>
                                                  getFieldValue("rfc") === "XEXX010101000" && (
                                                    <Row gutter={[16, 0]}>
                                                      <Col xs={24} md={12} lg={12}>
                                                        <FormItem
                                                          {...restField}
                                                          name={[name, "clienteNombre"]}
                                                          fieldKey={[fieldKey, "clienteNombre"]}
                                                          label="Cliente"
                                                          margin
                                                          pattern
                                                          max={200}
                                                          labelCol={{ span: 8 }}
                                                          wrapperCol={{ span: 16 }}
                                                          tooltip="Nombre del cliente para esta dirección (extranjero)"
                                                        >
                                                          <InputItem placeholder="Ej: ACME EUROPE B.V." />
                                                        </FormItem>
                                                      </Col>
                                                      <Col xs={24} md={12} lg={12}>
                                                        <FormItem
                                                          {...restField}
                                                          name={[name, "clienteRfc"]}
                                                          fieldKey={[fieldKey, "clienteRfc"]}
                                                          label="RFC"
                                                          margin
                                                          pattern
                                                          max={50}
                                                          labelCol={{ span: 8 }}
                                                          wrapperCol={{ span: 16 }}
                                                          tooltip="RFC / Tax ID del cliente para esta dirección"
                                                        >
                                                          <InputItem placeholder="Ej: NL000111222B01" />
                                                        </FormItem>
                                                      </Col>
                                                      {arrayKey === 0 && (
                                                        <Col span={24}>
                                                          <FormItem
                                                            {...restField}
                                                            name={[name, "direccionExtranjera"]}
                                                            fieldKey={[fieldKey, "direccionExtranjera"]}
                                                            label="Dirección (extranjero)"
                                                            margin
                                                            pattern
                                                            max={300}
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            tooltip="Domicilio en texto libre para clientes extranjeros. Es lo que se imprime en la factura. Los saltos de linea se respetan en el PDF."
                                                          >
                                                            <TextAreaItem
                                                              rows={3}
                                                              placeholder={"Ej:\nKeizersgracht 123\n1015 CJ Amsterdam\nNetherlands"}
                                                            />
                                                          </FormItem>
                                                        </Col>
                                                      )}
                                                    </Row>
                                                  )
                                                }
                                              </FormItem>
                                            </Col>
                                        </Row>
                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "referencia"]}
                                                fieldKey={[fieldKey, "referencia"]}
                                                label="Referencia"
                                                max={50}
                                                margin
                                                pattern
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 14 }}
                                                tooltip={{
                                                  title:
                                                    "Referencia de la dirección, ejemplo: CUARTO1, C1, etc",
                                                }}
                                              >
                                                <InputItem placeholder="Refencia de la dirección" />
                                              </FormItem>
                                            </Col>
                                          </Row>

                                          <FormItem
                                            shouldUpdate={(prevValues, curValues) =>
                                              prevValues.usarAdenda !== curValues.usarAdenda ||
                                              prevValues.adendaActiva !== curValues.adendaActiva
                                            }
                                            noStyle
                                          >
                                            {({ getFieldValue }) => {
                                              const usaAdenda = getFieldValue("usarAdenda");
                                              const esMabe = getFieldValue("adendaActiva") === "Mabe";
                                              return (
                                                (usaAdenda && esMabe) && (
                                                  <Row gutter={[16, 0]}>
                                                    <Col span={24}>
                                                      <FormItem
                                                        {...restField}
                                                        name={[name, "plantaEntregaId"]}
                                                        fieldKey={[fieldKey, "plantaEntregaId"]}
                                                        label="Planta de Entrega"
                                                        margin
                                                        labelCol={{ span: 6 }}
                                                        wrapperCol={{ span: 14 }}
                                                      >
                                                        <SelectItem
                                                          placeholder="Seleccionar planta de entrega"
                                                          showSearch
                                                          filterOption={false}
                                                          mostrarCarga
                                                          loading={
                                                            this.state.loadingPlantasEntrega?.[fieldKey]
                                                          }
                                                          notFoundContent={
                                                            this.state.loadingPlantasEntrega?.[fieldKey]
                                                              ? "Buscando...."
                                                              : "Sin resultados"
                                                          }
                                                          onSearch={(val) =>
                                                            this.onSearchPlantaEntrega(val, fieldKey)
                                                          }
                                                          onFocus={() =>
                                                            this.onSearchPlantaEntrega("", fieldKey)
                                                          }
                                                        >
                                                          {!this.state.objetoPlantasEntrega?.[fieldKey] ||
                                                          this.state.objetoPlantasEntrega[fieldKey]
                                                            .length === 0 ? (
                                                            <Option disabled>
                                                              Escribe ID o Centro de Distribución
                                                            </Option>
                                                          ) : (
                                                            this.state.objetoPlantasEntrega[fieldKey]
                                                          )}
                                                        </SelectItem>
                                                      </FormItem>
                                                    </Col>
                                                  </Row>
                                                )
                                              );
                                            }}
                                          </FormItem>

                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                label="Calle"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 14 }}
                                              >
                                                <Row gutter={8}>
                                                  <Col span={14}>
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "calle"]}
                                                      fieldKey={[fieldKey, "calle"]}
                                                      max={200}
                                                      pattern
                                                      noStyle
                                                    >
                                                      <InputItem placeholder="Calle" />
                                                    </FormItem>
                                                  </Col>
                                                  <Col span={5}>
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "numeroCalle"]}
                                                      fieldKey={[fieldKey, "numeroCalle"]}
                                                      noStyle
                                                    >
                                                      <InputItem placeholder="Número" numeroCalle />
                                                    </FormItem>
                                                  </Col>
                                                  <Col span={5}>
                                                    <FormItem
                                                      name={[name, "numeroInterior"]}
                                                      fieldKey={[fieldKey, "numeroInterior"]}
                                                      pattern
                                                      noStyle
                                                    >
                                                      <InputItem placeholder="Interior" />
                                                    </FormItem>
                                                  </Col>
                                                </Row>
                                              </FormItem>
                                            </Col>
                                          </Row>

                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "coloniaId"]}
                                                fieldKey={[fieldKey, "coloniaId"]}
                                                label="C.P."
                                                margin
                                                required={arrayKey === 0}
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 14 }}
                                              >
                                                <SelectItem
                                                  placeholder="Código Postal"
                                                  onSearch={(coloniaId) => {
                                                    this.onSearchColonia(coloniaId, arrayKey);
                                                  }}
                                                  onSelect={(coloniaId) => {
                                                    this.onSelectColoniaId(coloniaId, arrayKey);
                                                  }}
                                                >
                                                  {!this.state.objetoColonias[fieldKey] ? (
                                                    <Option disabled>
                                                      Eliga primero un municipio
                                                    </Option>
                                                  ) : (
                                                    this.state.objetoColonias[fieldKey]
                                                  )}
                                                  <Option disabled>
                                                    Busque por codigo postal
                                                  </Option>
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                          </Row>

                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "colonia"]}
                                                fieldKey={[fieldKey, "colonia"]}
                                                label="Colonia"
                                                margin
                                                pattern
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 14 }}
                                              >
                                                <InputItem placeholder="Colonia" />
                                              </FormItem>
                                            </Col>
                                          </Row>

                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "paisId"]}
                                                fieldKey={[fieldKey, "paisId"]}
                                                label="País"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 14 }}
                                              >
                                                <SelectItem placeholder="Pais">
                                                  {this.state.objetoPaises}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "estadoId"]}
                                                fieldKey={[fieldKey, "estadoId"]}
                                                label="Estado"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 14 }}
                                              >
                                                <SelectItem
                                                  placeholder="Estado"
                                                  onChange={(e) => this.onChangeEstado(e, fieldKey)}
                                                >
                                                  {this.state.objetoEstados}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "municipioId"]}
                                                fieldKey={[fieldKey, "municipioId"]}
                                                label="Municipio"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 14 }}
                                              >
                                                <SelectItem
                                                  placeholder="Municipio"
                                                  onChange={(e) => this.onChangeMunicipio(e, fieldKey)}
                                                >
                                                  {!this.state.objetoMunicipios[fieldKey] ? (
                                                    <Option disabled>
                                                      Eliga primero un estado
                                                    </Option>
                                                  ) : (
                                                    this.state.objetoMunicipios[fieldKey]
                                                  )}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                          </Row>
                                        </DynamicCardForm>
                                      </Col>

                                      <Col span={11} xs={24} sm={24} lg={11} xl={11}>
                                        <DynamicCardForm title={<span>Contacto en Dirección</span>}>
                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "descripcion"]}
                                                fieldKey={[fieldKey, "descripcion"]}
                                                label="Contacto"
                                                margin
                                                pattern
                                                labelCol={{ span: 7 }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <InputItem placeholder="Contacto" />
                                              </FormItem>
                                            </Col>
                                          </Row>

                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                label="Teléfono"
                                                name={[name, "telefono"]}
                                                fieldKey={[fieldKey, "telefono"]}
                                                number
                                                margin
                                                labelCol={{ span: 7 }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <InputNumberItem placeholder="Teléfono" celular />
                                              </FormItem>
                                            </Col>
                                          </Row>

                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                label="Correo"
                                                name={[name, "correo"]}
                                                fieldKey={[fieldKey, "correo"]}
                                                pattern
                                                max={200}
                                                email
                                                margin
                                                labelCol={{ span: 7 }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <InputItem placeholder="Correo" />
                                              </FormItem>
                                            </Col>
                                          </Row>

                                          <Row gutter={[16, 0]}>
                                            <Col span={24}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "observaciones"]}
                                                fieldKey={[fieldKey, "observaciones"]}
                                                label="Observaciones"
                                                margin
                                                pattern
                                                labelCol={{ span: 7 }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <InputItem placeholder="Notas adicionales" />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                        </DynamicCardForm>
                                      </Col>
                                    </Row>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        marginTop: "12px",
                                      }}
                                    >
                                      <ButtonItem
                                        type="primary"
                                        danger
                                        onClick={() => remove(name)}
                                      >
                                        Eliminar Dirección
                                      </ButtonItem>
                                    </div>
                                    </div>
                                  </React.Fragment>
                                )
                              )}
                              <FormItem noStyle>
                                <ButtonItem
                                  style={{ marginTop: 10, marginBottom: 10 }}
                                  type="dashed"
                                  cyan
                                  onClick={() => add()}
                                  block
                                  icon={<PlusOutlined />}
                                >
                                  Agregar Dirección
                                </ButtonItem>
                              </FormItem>
                            </>
                          )}
                        </FormInitial.List>
                      </>
                    )
                  },
                  {
                    key: '6',
                    label: 'Contabilidad',
                    forceRender: true,
                    customContent: (
                      <>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const tipoDeClienteId = getFieldValue("tipoClienteId");
                            const tipoDeCliente = tipoDeClienteId
                              ? this.state.todasTipoDeCliente.find(
                                (valueTodos) =>
                                  valueTodos._id.toString() ===
                                  tipoDeClienteId.toString()
                              )
                              : null;
                            const disabled = tipoDeCliente?.generarCuentasAutomatico
                              ? false
                              : true;
                            return (
                              <Row gutter={16}>
                                {/* CUENTAS CLIENTE */}
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <DynamicCardForm title={<span>Cuentas Cliente</span>}>
                                    <Row>
                                      <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          label="Cliente"
                                          name="cuentaClienteId"
                                          margin
                                          tooltip="Selecciona primero un tipo de cliente"
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Cliente"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col span={2}></Col>
                                    </Row>
                                    <Row>
                                      <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          name="cuentaAnticipoId"
                                          label="Anticipo"
                                          margin
                                          tooltip="Selecciona primero un tipo de cliente"
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Anticipo"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col
                                        span={2}
                                        xs={2}
                                        sm={2}
                                        lg={2}
                                        xl={2}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <FormItem
                                          noStyle
                                          name="generarCuentaAnticipoId"
                                          valuePropName="checked"
                                          initialValue={true}
                                        >
                                          <Checkbox
                                            disabled={disabled}
                                            style={{ marginTop: "auto" }}
                                          ></Checkbox>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                </Col>
                                {/* CUENTAS ADICIONALES */}
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <DynamicCardForm title={<span>Cuentas Adicionales</span>}>
                                    <Row>
                                      <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          label="Fondo Garantía"
                                          tooltip="Selecciona primero un tipo de cliente"
                                          margin
                                          name="cuentaFonGarId"
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Fondo de Garantía"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col
                                        span={2}
                                        xs={2}
                                        sm={2}
                                        lg={2}
                                        xl={2}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <FormItem
                                          noStyle
                                          name="generarCuentaFonGarId"
                                          valuePropName="checked"
                                          initialValue={true}
                                        >
                                          <Checkbox
                                            disabled={disabled}
                                            style={{ marginTop: "auto" }}
                                          ></Checkbox>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          label="Acreedor"
                                          name="cuentaDeudorId"
                                          margin
                                          tooltip="Selecciona primero un tipo de cliente"
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Acreedor"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col
                                        span={2}
                                        xs={2}
                                        sm={2}
                                        lg={2}
                                        xl={2}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <FormItem
                                          noStyle
                                          name="generarCuentaDeudorId"
                                          valuePropName="checked"
                                          initialValue={true}
                                        >
                                          <Checkbox
                                            disabled={disabled}
                                            style={{ marginTop: "auto" }}
                                          ></Checkbox>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                </Col>
                              </Row>
                            );
                          }}
                        </FormItem>
                      </>
                    )
                  },
                  ...(this.props.complementoDetallista
                    ? [{
                        key: '7',
                        label: 'Detallista',
                        forceRender: true,
                        customContent: (
                          <>
                            <Row gutter={16}>
                              <Col span={24}>
                                <DynamicCardForm title={<span>Complemento Detallista</span>}>
                                  <FormItem
                                    label="Activar Complemento Detallista"
                                    name="complementoDetallista"
                                    margin
                                    initialValue={false}
                                    valuePropName="checked"
                                    tooltip="Al activar esta casilla se activa el complemento detallista para este cliente."
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      const complementoDetallista = getFieldValue(
                                        "complementoDetallista"
                                      );
                                      if (!complementoDetallista) {
                                        return (
                                          <p style={{ textAlign: "center", margin: 0, color: "#999" }}>
                                            Active el Complemento Detallista para capturar la información requerida.
                                          </p>
                                        );
                                      }
                                      return (
                                        <>
                                          <Row gutter={16}>
                                            {/* CONFIGURACIÓN DOCUMENTO */}
                                            <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                              <DynamicCardForm title={<span style={{ color: "#0098AD" }}>Configuración Documento</span>}>
                                                <FormItem
                                                  name="type"
                                                  label="Type"
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                >
                                                  <InputItem placeholder="Type" />
                                                </FormItem>
                                                <FormItem
                                                  name="contentVersion"
                                                  label="ContentVersion"
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                >
                                                  <InputItem placeholder="ContentVersion" />
                                                </FormItem>
                                                <FormItem
                                                  name="documentStrucutreVersion"
                                                  label={
                                                    <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>
                                                      DocumentStrucutreVersion
                                                    </span>
                                                  }
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                >
                                                  <InputItem placeholder="DocumentStrucutreVersion" />
                                                </FormItem>
                                                <FormItem
                                                  name="documentStatus"
                                                  label="DocumentStatus"
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                  valuePropName="checked"
                                                  tooltip="Se pondra la funcion del mensaje: ORIGINAL DELETE COPY REEMPLAZA"
                                                >
                                                  <SwitchItem />
                                                </FormItem>
                                                <FormItem
                                                  name="requestForPaymentIdentification"
                                                  label={
                                                    <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>
                                                      RequestForPaymentIdentification
                                                    </span>
                                                  }
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                  valuePropName="checked"
                                                  tooltip="Se pondra el tipo de transaccion en entityType: INVOICE DEBIT_NOTE CREDIT_NOTE HONORARY_RECEIPT TRANSPORT_DOCUMENT"
                                                >
                                                  <SwitchItem />
                                                </FormItem>
                                                <FormItem
                                                  label="SpecialInstruction"
                                                  margin
                                                  name="specialInstruction"
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                >
                                                  <SelectItem placeholder="SpecialInstruction">
                                                    <Option value={undefined}>Nada</Option>
                                                    <Option value="ZZZ">
                                                      ZZZ - Importe con letra
                                                    </Option>
                                                    <Option disabled value="AAB">
                                                      AAB - Condiciones de pago
                                                    </Option>
                                                    <Option disabled value="DUT">
                                                      DUT - Informacion de impuestos
                                                      (Pedimentos)
                                                    </Option>
                                                    <Option disabled value="PUR">
                                                      PUR - Informacion de compras
                                                    </Option>
                                                  </SelectItem>
                                                </FormItem>
                                              </DynamicCardForm>
                                            </Col>
                                            {/* REFERENCIAS */}
                                            <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                              <DynamicCardForm title={<span style={{ color: "#0098AD" }}>Referencias</span>}>
                                                <FormItem
                                                  name="orderIdentification"
                                                  label="OrderIdentification"
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                  valuePropName="checked"
                                                  tooltip="Se pondra el numero de pedido: ON - Orden de compra"
                                                >
                                                  <SwitchItem
                                                    onChange={(value) =>
                                                      !value
                                                        ? this.formRef.current.setFieldsValue({
                                                          referenceDateOrderIdentification: false,
                                                        })
                                                        : null
                                                    }
                                                  />
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    const orderIdentification = getFieldValue(
                                                      "orderIdentification"
                                                    );
                                                    return (
                                                      <FormItem
                                                        name="referenceDateOrderIdentification"
                                                        label="ReferenceDate"
                                                        margin
                                                        labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                        wrapperCol={{ span: 13 }}
                                                        valuePropName="checked"
                                                        tooltip="Se pedira la fecha de referencia"
                                                      >
                                                        <SwitchItem
                                                          disabled={!orderIdentification}
                                                        />
                                                      </FormItem>
                                                    );
                                                  }}
                                                </FormItem>
                                                <FormItem
                                                  name="additionalInformation"
                                                  label={
                                                    <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>
                                                      AdditionalInformation
                                                    </span>
                                                  }
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                  valuePropName="checked"
                                                  tooltip="Se eligira la referencia adicional y el tipo"
                                                >
                                                  <SwitchItem />
                                                </FormItem>
                                                <FormItem
                                                  name="deliveryNote"
                                                  label="DeliveryNote"
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                  valuePropName="checked"
                                                  tooltip="Se pedira el numero de folio"
                                                >
                                                  <SwitchItem
                                                    onChange={(value) =>
                                                      !value
                                                        ? this.formRef.current.setFieldsValue({
                                                          referenceDateDeliveryNote: false,
                                                        })
                                                        : null
                                                    }
                                                  />
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    const deliveryNote =
                                                      getFieldValue("deliveryNote");
                                                    return (
                                                      <FormItem
                                                        name="referenceDateDeliveryNote"
                                                        label="ReferenceDate"
                                                        margin
                                                        labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                        wrapperCol={{ span: 13 }}
                                                        valuePropName="checked"
                                                        tooltip="Se pedira la fecha de referencia"
                                                      >
                                                        <SwitchItem disabled={!deliveryNote} />
                                                      </FormItem>
                                                    );
                                                  }}
                                                </FormItem>
                                              </DynamicCardForm>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            {/* COMPRADOR */}
                                            <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                              <DynamicCardForm title={<span style={{ color: "#0098AD" }}>Comprador</span>}>
                                                <FormItem
                                                  name="buyer"
                                                  label="Buyer"
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                  valuePropName="checked"
                                                  tooltip="Datos del comprador"
                                                >
                                                  <SwitchItem
                                                    onChange={(value) =>
                                                      !value
                                                        ? this.formRef.current.setFieldsValue({
                                                          glnBuyer: undefined,
                                                          textBuyer: undefined,
                                                        })
                                                        : null
                                                    }
                                                  />
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    const buyer = getFieldValue("buyer");
                                                    return (
                                                      <>
                                                        <FormItem
                                                          name="glnBuyer"
                                                          label="Gln"
                                                          margin
                                                          labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                          wrapperCol={{ span: 13 }}
                                                          tooltip="Codigo del comprador"
                                                        >
                                                          <InputItem disabled={!buyer} />
                                                        </FormItem>
                                                        <FormItem
                                                          name="textBuyer"
                                                          label={
                                                            <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>
                                                              PersonOrDepartmentName
                                                            </span>
                                                          }
                                                          margin
                                                          labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                          wrapperCol={{ span: 13 }}
                                                          tooltip="Contacto de compras"
                                                        >
                                                          <InputItem disabled={!buyer} />
                                                        </FormItem>
                                                      </>
                                                    );
                                                  }}
                                                </FormItem>
                                              </DynamicCardForm>
                                            </Col>
                                            {/* PROVEEDOR */}
                                            <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                              <DynamicCardForm title={<span style={{ color: "#0098AD" }}>Proveedor</span>}>
                                                <FormItem
                                                  name="seller"
                                                  label="Seller"
                                                  margin
                                                  labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                  wrapperCol={{ span: 13 }}
                                                  valuePropName="checked"
                                                  tooltip="Datos del proveedor"
                                                >
                                                  <SwitchItem
                                                    onChange={(value) =>
                                                      !value
                                                        ? this.formRef.current.setFieldsValue({
                                                          glnSeller: undefined,
                                                          alternatePartyIdentificationType:
                                                            undefined,
                                                          alternatePartyIdentification:
                                                            undefined,
                                                        })
                                                        : null
                                                    }
                                                  />
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    const seller = getFieldValue("seller");
                                                    return (
                                                      <>
                                                        <FormItem
                                                          name="glnSeller"
                                                          label="Gln"
                                                          margin
                                                          labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                          wrapperCol={{ span: 13 }}
                                                          tooltip="Codigo del proveedor"
                                                        >
                                                          <InputItem disabled={!seller} />
                                                        </FormItem>
                                                        <FormItem
                                                          label={
                                                            <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>
                                                              AlternatePartyIdentificationType
                                                            </span>
                                                          }
                                                          margin
                                                          name="alternatePartyIdentificationType"
                                                          labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                          wrapperCol={{ span: 13 }}
                                                        >
                                                          <SelectItem
                                                            placeholder="AlternatePartyIdentificationType"
                                                            disabled={!seller}
                                                          >
                                                            <Option value={undefined}>
                                                              Nada
                                                            </Option>
                                                            <Option value="SELLER_ASSIGNED_IDENTIFIER_FOR_A_PARTY">
                                                              SELLER_ASSIGNED_IDENTIFIER_FOR_A_PARTY
                                                              - Número interno del proveedor
                                                            </Option>
                                                            <Option value="IEPS_REFERENCE">
                                                              IEPS_REFERENCE - Referencia
                                                              signada para el IEPS
                                                            </Option>
                                                          </SelectItem>
                                                        </FormItem>
                                                        <FormItem
                                                          name="alternatePartyIdentification"
                                                          label={
                                                            <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>
                                                              AlternatePartyIdentification
                                                            </span>
                                                          }
                                                          margin
                                                          labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                          wrapperCol={{ span: 13 }}
                                                          tooltip="Identificacion secundaria del proveedor"
                                                        >
                                                          <InputItem disabled={!seller} />
                                                        </FormItem>
                                                      </>
                                                    );
                                                  }}
                                                </FormItem>
                                              </DynamicCardForm>
                                            </Col>
                                          </Row>
                                        </>
                                      );
                                    }}
                                  </FormItem>
                                </DynamicCardForm>
                              </Col>
                            </Row>
                          </>
                        )
                      }]
                    : []),
                  {
                    key: '8',
                    label: 'Complementos',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm title={<span>Complementos</span>}>
                              {this.state.factorajeFinancieroCXC ? (
                                <FormItem
                                  label="Activar Factoraje Financiero"
                                  name="factorajeFinancieroCXC"
                                  margin
                                  valuePropName="checked"
                                  tooltip="Al activar esta casilla se activa el factoraje financiero en este cliente."
                                >
                                  <SwitchItem />
                                </FormItem>
                              ) : null}
                              {this.state.complementoComercioExterior ? (
                                <FormItem
                                  label="Activar Complemento Comercio Exterior"
                                  name="complementoComercioExterior"
                                  margin
                                  valuePropName="checked"
                                  tooltip="Al activar esta casilla se activa el complemento de comercio exterior en este cliente."
                                >
                                  <SwitchItem />
                                </FormItem>
                              ) : null}
                              <FormItem
                                label="Usar Leyendas Fiscales"
                                name="usarLeyendasFiscales"
                                margin
                                valuePropName="checked"
                                tooltip="Al activar esta casilla se agrega el complemento de Leyendas Fiscales al CFDI de las facturas de este cliente."
                              >
                                <SwitchItem />
                              </FormItem>
                              <FormItem
                                shouldUpdate={(prevValues, curValues) =>
                                  prevValues.usarLeyendasFiscales !== curValues.usarLeyendasFiscales
                                }
                                noStyle
                              >
                                {({ getFieldValue }) =>
                                  getFieldValue("usarLeyendasFiscales") ? (
                                    <FormListLeyendasFiscales mostrarAviso />
                                  ) : null
                                }
                              </FormItem>
                              <FormItem
                                label="Usar Adenda"
                                name="usarAdenda"
                                margin
                                valuePropName="checked"
                                tooltip="Al activar esta casilla podrás seleccionar y configurar la adenda requerida para el Comprobante Fiscal."
                              >
                                <SwitchItem
                                  onChange={(checked) => {
                                    if (!checked) {
                                      this.formRef.current.setFieldsValue({ adendaActiva: undefined });
                                    }
                                  }}
                                />
                              </FormItem>
                              <FormItem
                                shouldUpdate={(prevValues, curValues) =>
                                  prevValues.usarAdenda !== curValues.usarAdenda ||
                                  prevValues.adendaActiva !== curValues.adendaActiva
                                }
                                noStyle
                              >
                                {({ getFieldValue }) => {
                                  const usaAdenda = getFieldValue("usarAdenda");
                                  const adendaSeleccionada = getFieldValue("adendaActiva");

                                  return usaAdenda ? (
                                    <>
                                      <FormItem
                                        name="adendaActiva"
                                        label="Selecciona la Adenda"
                                        margin
                                        rules={[{ required: true, message: "¡Falta clavar la adenda, carnal!" }]}
                                      >
                                        <SelectItem placeholder="Elige la adenda a utilizar">
                                          <Option value="Mabe">Mabe</Option>
                                          <Option value="Viscofan">Viscofan</Option>
                                          <Option value="Lesaffre">Lesaffre</Option>
                                          <Option value="Advans">Advans</Option>
                                          <Option value="Continental">Continental Tire</Option>
                                          <Option value="Goodyear">Goodyear</Option>
                                        </SelectItem>
                                      </FormItem>

                                      {adendaSeleccionada === "Mabe" && (
                                        <>
                                          <FormItem
                                            name="referencia1"
                                            label="Referencia 1 (Mabe)"
                                            margin
                                            pattern
                                            rules={[
                                              {
                                                required: true,
                                                message: "La Referencia 1 es obligatoria para Mabe",
                                              },
                                            ]}
                                            tooltip="Ingrese el dato proporcionado para la referencia 1."
                                          >
                                            <InputItem placeholder="Referencia 1" />
                                          </FormItem>
                                          <FormItem
                                            name="referencia2"
                                            label="Referencia 2 (Mabe)"
                                            margin
                                            pattern
                                            tooltip="Ingrese el dato proporcionado para la referencia 2."
                                          >
                                            <InputItem placeholder="Referencia 2" />
                                          </FormItem>
                                          <FormItem
                                            name="usarUnidad"
                                            label="Usar unidad SAT del insumo"
                                            margin
                                            valuePropName="checked"
                                            tooltip="Si se activa esta casilla se usara la unidad de medida SAT del insumo, si no se activa se usara por defecto UN."
                                          >
                                            <SwitchItem />
                                          </FormItem>
                                        </>
                                      )}

                                      {adendaSeleccionada === "Viscofan" && (
                                        <>
                                          <FormItem
                                            name="viscofanCorreo"
                                            label="Correo Electrónico"
                                            margin
                                            required
                                            rules={[
                                              {
                                                type: "email",
                                                message: "El formato de correo no es válido",
                                              },
                                            ]}
                                            tooltip="Ingresa el correo electrónico para Viscofan."
                                          >
                                            <InputItem placeholder="correo@ejemplo.com" />
                                          </FormItem>
                                          <Alert
                                            message="Aviso Importante"
                                            description="Para la adenda Viscofan, asegúrate de haber llenado el campo *Código Proveedor* que se encuentra en la pestaña *General*."
                                            type="warning"
                                            showIcon
                                            style={{ marginBottom: '10px' }}
                                          />
                                        </>
                                      )}

                                    {adendaSeleccionada === "Advans" && (
                                          <>
                                            <FormItem
                                              name="advansLeyenda"
                                              label="Leyenda Operación"
                                              margin
                                              pattern
                                              required
                                              tooltip="Texto legal para el campo _8 de la adenda Advans (operación virtual / IMMEX)."
                                            >
                                              <TextAreaItem
                                                placeholder="Ej: Operación virtual conforme al art. 29 fracción I de la LIVA, arts. 105 y 112 de la Ley Aduanera y reglas 5.2.5, 5.2.6 y 4.3.21 de las RGCE vigentes. IMMEX <empresa>: <num> Embarcado A: <razón social> RFC <rfc>, <domicilio>"
                                                rows={5}
                                              />
                                            </FormItem>
                                            <FormItem
                                              name="advansReceptorCalle"
                                              label="Receptor Calle"
                                              margin
                                              pattern
                                              required
                                            >
                                              <InputItem placeholder="Ej: KEIZERSGRACHT 250" />
                                            </FormItem>
                                            <FormItem
                                              name="advansReceptorColonia"
                                              label="Receptor Colonia"
                                              margin
                                              pattern
                                              required
                                            >
                                              <InputItem placeholder="Ej: 1016 EV" />
                                            </FormItem>
                                            <FormItem
                                              name="advansReceptorLocalidad"
                                              label="Receptor Localidad"
                                              margin
                                              pattern
                                              required
                                            >
                                              <InputItem placeholder="Ej: AMSTERDAM, NETHERLANDS" />
                                            </FormItem>
                                            <FormItem
                                              name="advansReceptorMunicipio"
                                              label="Receptor Municipio"
                                              margin
                                              pattern
                                              required
                                            >
                                              <InputItem placeholder="Ej: AMSTERDAM, NETHERLANDS" />
                                            </FormItem>
                                            <FormItem
                                              name="advansReceptorEstado"
                                              label="Receptor Estado"
                                              margin
                                              pattern
                                              required
                                              tooltip="Código del estado/provincia según ISO (2 letras)"
                                            >
                                              <InputItem placeholder="Ej: NH" />
                                            </FormItem>
                                            <FormItem
                                              name="advansReceptorPais"
                                              label="Receptor País"
                                              margin
                                              pattern
                                              required
                                              tooltip="Código de país ISO 3 letras"
                                            >
                                              <InputItem placeholder="Ej: NLD" />
                                            </FormItem>
                                            <FormItem
                                              name="advansReceptorCodigoPostal"
                                              label="Receptor C.P."
                                              margin
                                              pattern
                                              required
                                            >
                                              <InputItem placeholder="Ej: 1016EV" />
                                            </FormItem>
                                          </>
                                        )}

                                      {adendaSeleccionada === "Continental" && (
                                        <>
                                          <FormItem
                                            name="continentalCodigoCompania"
                                            label="Código de Compañía"
                                            margin
                                            pattern
                                            required
                                            tooltip="Código de la compañía Continental que recibe la factura. Respeta los ceros a la izquierda."
                                          >
                                            <InputItem placeholder="Ej: 088" />
                                          </FormItem>
                                          <FormItem
                                            name="continentalTipoProv"
                                            label="Tipo de Proveedor"
                                            margin
                                            pattern
                                            required
                                            tooltip="Clave de tipo de proveedor asignada por Continental."
                                          >
                                            <InputItem placeholder="Ej: P" />
                                          </FormItem>
                                          <Alert
                                            message="Aviso Importante"
                                            description="Para la adenda Continental Tire, los datos que cambian en cada venta se capturan en la venta, no aquí: la Orden de Compra se manda como Pedido y Referencia_PO, y el campo Atención a se manda como Solicitante. Si la venta no trae Orden de Compra, la adenda se manda como PO = SIN."
                                            type="warning"
                                            showIcon
                                            style={{ marginBottom: '10px' }}
                                          />
                                        </>
                                      )}

                                      {adendaSeleccionada === "Goodyear" && (
                                        <Alert
                                          message="Aviso Importante"
                                          description="La adenda Goodyear no necesita datos del cliente: lo único que se manda es la Orden de Compra, y ésa se captura en cada venta en el campo *O Compra*. Sin Orden de Compra la factura no se timbra."
                                          type="warning"
                                          showIcon
                                          style={{ marginBottom: '10px' }}
                                        />
                                      )}

                                      </>
                                    ) : null;
                                }}
                              </FormItem>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    )
                  },
                  {
                    key: '9',
                    label: 'Archivos',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm title={<span>Archivos del Cliente</span>}>
                              <FormItem
                                name="archivos"
                                margin
                                style={{
                                  display: "block",
                                  justifyContent: "flex-start",
                                  alignItems: "initial",
                                  textAlign: "left",
                                }}
                              >
                                <Upload
                                  showUploadList={{
                                    showRemoveIcon: true,
                                    showPreviewIcon: true,
                                    removeIcon: (file) => (
                                      <Popconfirm
                                        title="¿Seguro que quieres eliminar el archivo?"
                                        onConfirm={() => {
                                          this.onRemoveFile(file);
                                        }}
                                        okText="Si"
                                        cancelText="No"
                                      >
                                        <DeleteOutlined
                                          onClick={(e) => e.preventDefault()}
                                        />
                                      </Popconfirm>
                                    ),
                                  }}
                                  fileList={this.state.archivosCliente}
                                  customRequest={this.customRequestArchivos.bind(this)}
                                  multiple={true}
                                  onPreview={this.handlePreview}
                                  beforeUpload={this.beforeUploadArchivos}
                                >
                                  <ButtonItem
                                    icon={<UploadOutlined />}
                                    cyan
                                    disabled={this.state.archivosCliente.length >= this.state.maximoArchivos}
                                  >
                                    Agregar archivos
                                  </ButtonItem>
                                </Upload>
                              </FormItem>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    )
                  },
                  ...(this.state.complementoEmpresaAlterna
                    ? [{
                        key: '10',
                        label: 'Empresa Alterna',
                        forceRender: true,
                        customContent: (
                          <>
                            <Row gutter={16}>
                              <Col span={24}>
                                <DynamicCardForm title={<span>Empresa Alterna en Documentos</span>}>
                                  <Alert
                                    message="Empresa Alterna"
                                    description="Estos datos sustituirán a los de tu empresa en Remisión, Cotización y Pedido para este cliente. No afecta la Factura."
                                    type="info"
                                    showIcon
                                    style={{ marginBottom: 16 }}
                                  />
                                  <FormItem
                                    name={["empresaAlterna", "activo"]}
                                    label="Activar Empresa Alterna"
                                    margin
                                    valuePropName="checked"
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      const activo = getFieldValue(["empresaAlterna", "activo"]);
                                      if (!activo) return null;
                                      const persona = getFieldValue(["empresaAlterna", "persona"]);
                                      return (
                                        <>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem
                                                name={["empresaAlterna", "nombre"]}
                                                label="Nombre / Razón Social"
                                                margin
                                                pattern
                                                required
                                              >
                                                <InputItem placeholder="Nombre / Razón Social" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem
                                                name={["empresaAlterna", "persona"]}
                                                label="Persona Moral"
                                                margin
                                                valuePropName="checked"
                                              >
                                                <Checkbox />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          {!persona ? (
                                            <Row gutter={16}>
                                              <Col xs={24} md={12}>
                                                <FormItem name={["empresaAlterna", "apellidoPaterno"]} label="Apellido Paterno" margin pattern>
                                                  <InputItem placeholder="Apellido Paterno" />
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} md={12}>
                                                <FormItem name={["empresaAlterna", "apellidoMaterno"]} label="Apellido Materno" margin pattern>
                                                  <InputItem placeholder="Apellido Materno" />
                                                </FormItem>
                                              </Col>
                                            </Row>
                                          ) : null}
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "nombreComercial"]} label="Nombre Comercial" margin pattern>
                                                <InputItem placeholder="Nombre Comercial" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "rfc"]} label="RFC" margin pattern required>
                                                <InputItem placeholder="RFC" />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "correo"]} label="Correo" margin pattern email>
                                                <InputItem placeholder="correo@ejemplo.com" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "telefono"]} label="Teléfono" margin number>
                                                <InputNumberItem placeholder="Teléfono" celular />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "paisId"]} label="País" margin required>
                                                <SelectItem placeholder="País">
                                                  {this.state.objetoPaises}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "estadoId"]} label="Estado" margin required>
                                                <SelectItem placeholder="Estado" onChange={this.onChangeEstadoAlterna.bind(this)}>
                                                  {this.state.objetoEstados}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "municipioId"]} label="Municipio" margin required>
                                                <SelectItem placeholder="Municipio" onChange={this.onChangeMunicipioAlterna.bind(this)}>
                                                  {this.state.objetoMunicipiosAlterna === null ? (
                                                    <Option disabled>Elija primero un estado</Option>
                                                  ) : (
                                                    this.state.objetoMunicipiosAlterna
                                                  )}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "coloniaId"]} label="Colonia" margin required>
                                                <SelectItem placeholder="Colonia">
                                                  {this.state.objetoColoniasAlterna === null ? (
                                                    <Option disabled>Elija primero un municipio</Option>
                                                  ) : (
                                                    this.state.objetoColoniasAlterna
                                                  )}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={8}>
                                              <FormItem name={["empresaAlterna", "calle"]} label="Calle" margin pattern>
                                                <InputItem placeholder="Calle" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={8}>
                                              <FormItem name={["empresaAlterna", "numeroCalle"]} label="Número Exterior" margin>
                                                <InputItem placeholder="Número Exterior" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={8}>
                                              <FormItem name={["empresaAlterna", "numeroInterior"]} label="Número Interior" margin pattern>
                                                <InputItem placeholder="Número Interior" />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <FormItem label="Logo">
                                            <Upload
                                              accept="image/*"
                                              showUploadList={false}
                                              customRequest={this.onChangeArchivoLogoAlterna.bind(this)}
                                            >
                                              <ButtonItem blanco icon={<UploadOutlined />}>Subir logo</ButtonItem>
                                            </Upload>
                                            {this.state.base64LogoAlterna ? (
                                              <img
                                                src={this.state.base64LogoAlterna}
                                                alt="Logo Empresa Alterna"
                                                style={{ maxHeight: 80, marginLeft: 16, verticalAlign: "middle" }}
                                              />
                                            ) : null}
                                          </FormItem>
                                        </>
                                      );
                                    }}
                                  </FormItem>
                                </DynamicCardForm>
                              </Col>
                            </Row>
                          </>
                        )
                      }]
                    : []),
                  {
                    key: '11',
                    label: 'Cuentas Cliente',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm
                              title={
                                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                  Cuentas de Pago del Cliente
                                </span>
                              }
                              headerRight={
                                <span style={{ color: '#00BFD6', fontSize: 11 }}>
                                  Complemento de Pago
                                </span>
                              }
                            >
                              <Alert
                                message="Cuentas de Pago del Cliente"
                                description="Estas son las cuentas que el cliente utiliza para realizar sus pagos. Serán utilizadas para la completar los datos del Complemento de Pago."
                                type="info"
                                showIcon
                                style={{
                                  marginBottom: 20,
                                  borderRadius: 6,
                                  border: '1px solid #b8e8f0',
                                  background: 'linear-gradient(135deg, #f0fbfd 0%, #e6f7fa 100%)',
                                  fontSize: 13,
                                }}
                              />
                              <FormInitial.List name="cuentasBancoCliente">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.length > 0 && (
                                      <Row
                                        gutter={16}
                                        style={{
                                          marginBottom: 8,
                                          paddingLeft: '5px',
                                          paddingBottom: 8,
                                          borderBottom: '2px solid',
                                          borderImage: 'linear-gradient(90deg, #00BFD6 0%, #28d3ea 100%) 1',
                                        }}
                                      >
                                        <Col span={6}>
                                          <span style={{ fontWeight: 600, fontSize: 12, color: '#00BFD6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Descripción
                                          </span>
                                        </Col>
                                        <Col span={7}>
                                          <span style={{ fontWeight: 600, fontSize: 12, color: '#00BFD6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Banco (SAT)
                                          </span>
                                        </Col>
                                        <Col span={7}>
                                          <span style={{ fontWeight: 600, fontSize: 12, color: '#00BFD6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Cuenta / CLABE
                                          </span>
                                        </Col>
                                        <Col span={2} style={{ textAlign: 'center' }}>
                                          <span style={{ fontWeight: 600, fontSize: 12, color: '#00BFD6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Pred.
                                          </span>
                                        </Col>
                                        <Col span={2}></Col>
                                      </Row>
                                    )}

                                    {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                                      <Row
                                        key={key}
                                        gutter={16}
                                        align="top"
                                        style={{
                                          marginBottom: 0,
                                          backgroundColor: index % 2 === 0 ? '#ffffff' : '#f7fcfd',
                                          padding: '10px 5px',
                                          borderRadius: '4px',
                                          borderBottom: '1px solid #e6f7fa',
                                        }}
                                      >
                                        <Col span={6}>
                                          <FormItem
                                            {...restField}
                                            name={[name, "descripcion"]}
                                            fieldKey={[fieldKey, "descripcion"]}
                                            margin
                                          >
                                            <InputItem placeholder="Ej. BBVA Dólares" />
                                          </FormItem>
                                        </Col>

                                        <Col span={7}>
                                          <FormItem
                                            {...restField}
                                            name={[name, "bancoSatId"]}
                                            fieldKey={[fieldKey, "bancoSatId"]}
                                            required
                                            margin
                                          >
                                            <SelectItem placeholder="Seleccionar Banco">
                                              {this.state.objetoBancosSat}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>

                                        <Col span={7}>
                                          <FormItem
                                            {...restField}
                                            name={[name, "cuenta"]}
                                            fieldKey={[fieldKey, "cuenta"]}
                                            required
                                            margin
                                            pattern
                                          >
                                            <InputItem placeholder="10, 11 o 18 dígitos" />
                                          </FormItem>
                                        </Col>

                                        <Col span={2} style={{ textAlign: 'center', paddingTop: '5px' }}>
                                          {/* El valor vive en el formulario; la estrella solo lo refleja */}
                                          <FormItem
                                            {...restField}
                                            name={[name, "predeterminada"]}
                                            fieldKey={[fieldKey, "predeterminada"]}
                                            hidden
                                            valuePropName="checked"
                                          >
                                            <Checkbox />
                                          </FormItem>
                                          <FormItem noStyle shouldUpdate>
                                            {({ getFieldValue }) => {
                                              const esPredeterminada = !!getFieldValue([
                                                "cuentasBancoCliente",
                                                name,
                                                "predeterminada",
                                              ]);
                                              return (
                                                <ButtonItem
                                                  type="text"
                                                  title={
                                                    esPredeterminada
                                                      ? "Cuenta predeterminada, click para quitarla"
                                                      : "Marcar como cuenta predeterminada"
                                                  }
                                                  onClick={() => this.marcarCuentaPredeterminada(name)}
                                                  icon={
                                                    esPredeterminada ? (
                                                      <StarFilled style={{ color: '#FFC107', fontSize: '18px' }} />
                                                    ) : (
                                                      <StarOutlined style={{ color: '#ffffff', fontSize: '18px' }} />
                                                    )
                                                  }
                                                />
                                              );
                                            }}
                                          </FormItem>
                                        </Col>

                                        <Col span={2} style={{ textAlign: 'center', paddingTop: '5px' }}>
                                          <Popconfirm
                                            title="¿Eliminar esta cuenta?"
                                            onConfirm={() => remove(name)}
                                            okText="Sí"
                                            cancelText="No"
                                            placement="left"
                                          >
                                            <ButtonItem
                                              type="text"
                                              danger
                                              icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
                                            />
                                          </Popconfirm>
                                        </Col>
                                      </Row>
                                    ))}

                                    <div style={{ marginTop: 20, textAlign: 'center' }}>
                                      <ButtonItem
                                        type="dashed"
                                        cyan
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                        style={{ width: 280, borderRadius: 8, fontSize: 13, fontWeight: 600 }}
                                      >
                                        Agregar Nueva Cuenta Bancaria
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    )
                  },
                ]}
                formInstance={this.formRef.current}
              />
            </Form>
          </Spin>

          <ModalPrevisualizarArchivos
            file={currentPreviewFile}
            visible={filePreviewVisible}
            onClose={this.handleCloseFilePreview}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    complementoDetallista: state.empresa.complementoDetallista,
    escuela: state.empresa.escuela,
    permisoModificarParametosDeCredito:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6999ecf0153232381f120f72",
      )?.activado,
  };
};

export default connect(mapStateToProps)(AgregarCliente);